module.exports = __webpack_public_path__ + "static/media/img_discover-splash.47483947.png";